import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;



async function valanDates(payload) {
    const result = await axios.get(apiUrl + "/admin/get/valandates",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const ProfitLossPercentageServices = {
  
    valanDates
}